import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=865bfb72&scoped=true&"
import script from "./ProjectsView.vue?vue&type=script&lang=ts&"
export * from "./ProjectsView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=865bfb72&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865bfb72",
  null
  
)

export default component.exports